export default "__VITE_ASSET__BIRycyVn__"